var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row justify-center items-center"},[_c('vue-timepicker',{attrs:{"format":"mm:ss"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }